export default __webpack_public_path__ + "static/media/barcode.777ac502.jpg";